import { z } from "zod";

const PickupAddressSchema = z.object({
    addressType: z.literal("Pickup"), // Always "Pickup"
    lines: z.array(
        z.object({
            line1: z.string().trim().min(1, "Address Line 1 is required."),
            line2: z.string().trim().optional().default(""), // Optional but defaults to empty
        })
    ),
    city: z.string().trim().min(1, "City is required."),
    state: z.string().trim().min(1, "State selection is required."),
    pincode: z
        .string()
        .trim()
        .min(6, "Pincode must be exactly 6 digits.")
        .max(6, "Pincode must be exactly 6 digits.")
        .regex(/^\d{6}$/, "Please enter a valid 6-digit Indian pincode."),
    landmark: z.string().trim().optional().default(""), // Optional, defaults to empty
    isDefault: z.boolean().default(true), // Always true
    contactPerson: z.string().trim().min(1, "Contact Person is required."),
    contactPhone: z
        .string()
        .trim()
        .min(10, "Mobile number must be exactly 10 digits.")
        .max(10, "Mobile number must be exactly 10 digits.")
        .regex(/^\d{10}$/, "Please enter a valid 10-digit mobile number."),
    gstNumber: z
        .string()
        .trim()
        .optional()
        .default("")
        .refine((val) => val === "" || /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(val), {
            message: "Please enter a valid 15-digit GST Number.",
        }),
});

export default PickupAddressSchema;